import { Typography } from '@mui/material';
import { useVehicleTracking } from 'app-components/flux/vehicle/vehicleTracking';
import React from 'react';
import { useEffectOnce } from 'react-use';
import { makeStyles } from 'tss-react/mui';
import { EstimateInput, NameInput } from '../VehicleFields';

const useStyles = makeStyles()((theme) => ({
  mainTitle: {
    marginBottom: theme.spacing(2),
  },
}));

export const ManualStep = () => {
  const { classes } = useStyles();
  const { trackOnce } = useVehicleTracking();

  useEffectOnce(() => {
    trackOnce('kbbStepManual');
  });

  return (
    <>
      <Typography variant='headlineRegular' className={classes.mainTitle}>
        Fill in your automobile&apos;s details.
      </Typography>
      <NameInput />
      <EstimateInput />
    </>
  );
};
